import { render } from "./DepotPricingManagement.html?vue&type=template&id=08deed15&scoped=true"
import script from "./DepotPricingManagement.js?vue&type=script&lang=js"
export * from "./DepotPricingManagement.js?vue&type=script&lang=js"

import "./DepotPricingManagement.css?vue&type=style&index=0&id=08deed15&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08deed15"]])

export default __exports__